// extracted by mini-css-extract-plugin
module.exports = {"white":"#fff","black":"#444","lightGrey":"#fbfbfb","darkGrey":"#717171","darkBlue":"#021d7b","lightBlue":"#0570e0","cyan":"#06def8"};